import { api } from '../api';
import { tags } from '../tags';
import type { AllMetadata } from '../types';

/* istanbul ignore file */

export const metaApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    metadata: builder.query<AllMetadata, void>({
      query: () => 'api/meta/all/',
      providesTags: (result) =>
        result ? Object.keys(result).map((key) => ({ type: tags.metadata, id: key })) : [tags.metadata],
      // keep for N seconds (1200 seconds == 20 minutes)
      keepUnusedDataFor: 1200,
    }),
  }),
});
